__turbopack_context__.v({
  "appLoading": "feedback-module__yprQXG__appLoading",
  "appLoadingFullscreen": "feedback-module__yprQXG__appLoadingFullscreen",
  "appLoadingInline": "feedback-module__yprQXG__appLoadingInline",
  "appLoadingInner": "feedback-module__yprQXG__appLoadingInner",
  "appLoadingMessage": "feedback-module__yprQXG__appLoadingMessage",
  "appLoadingPanel": "feedback-module__yprQXG__appLoadingPanel",
  "authPending": "feedback-module__yprQXG__authPending",
  "authPendingActivity": "feedback-module__yprQXG__authPendingActivity",
  "authPendingAmbient": "feedback-module__yprQXG__authPendingAmbient",
  "authPendingBar": "feedback-module__yprQXG__authPendingBar",
  "authPendingBody": "feedback-module__yprQXG__authPendingBody",
  "authPendingBrand": "feedback-module__yprQXG__authPendingBrand",
  "authPendingBrandCopy": "feedback-module__yprQXG__authPendingBrandCopy",
  "authPendingBrandMeta": "feedback-module__yprQXG__authPendingBrandMeta",
  "authPendingBrandName": "feedback-module__yprQXG__authPendingBrandName",
  "authPendingFooter": "feedback-module__yprQXG__authPendingFooter",
  "authPendingFooterSep": "feedback-module__yprQXG__authPendingFooterSep",
  "authPendingFullscreen": "feedback-module__yprQXG__authPendingFullscreen",
  "authPendingHeader": "feedback-module__yprQXG__authPendingHeader",
  "authPendingHint": "feedback-module__yprQXG__authPendingHint",
  "authPendingInner": "feedback-module__yprQXG__authPendingInner",
  "authPendingLabel": "feedback-module__yprQXG__authPendingLabel",
  "authPendingLive": "feedback-module__yprQXG__authPendingLive",
  "authPendingLiveDot": "feedback-module__yprQXG__authPendingLiveDot",
  "authPendingMark": "feedback-module__yprQXG__authPendingMark",
  "authPendingMessage": "feedback-module__yprQXG__authPendingMessage",
  "authPendingPanel": "feedback-module__yprQXG__authPendingPanel",
  "authPendingPulse": "feedback-module__yprQXG__authPendingPulse",
  "authPendingStrip": "feedback-module__yprQXG__authPendingStrip",
  "authPendingValue": "feedback-module__yprQXG__authPendingValue",
  "authPendingWorkspace": "feedback-module__yprQXG__authPendingWorkspace",
  "bar": "feedback-module__yprQXG__bar",
  "barsWrap": "feedback-module__yprQXG__barsWrap",
  "bootstrap": "feedback-module__yprQXG__bootstrap",
  "connection": "feedback-module__yprQXG__connection",
  "connectionConnecting": "feedback-module__yprQXG__connectionConnecting",
  "connectionDot": "feedback-module__yprQXG__connectionDot",
  "connectionDown": "feedback-module__yprQXG__connectionDown",
  "connectionError": "feedback-module__yprQXG__connectionError",
  "connectionLabel": "feedback-module__yprQXG__connectionLabel",
  "connectionOk": "feedback-module__yprQXG__connectionOk",
  "connectionPulse": "feedback-module__yprQXG__connectionPulse",
  "dark-theme": "feedback-module__yprQXG__dark-theme",
  "dot": "feedback-module__yprQXG__dot",
  "dotsWrap": "feedback-module__yprQXG__dotsWrap",
  "orbitDot": "feedback-module__yprQXG__orbitDot",
  "orbitSvg": "feedback-module__yprQXG__orbitSvg",
  "overlay": "feedback-module__yprQXG__overlay",
  "overlayDark": "feedback-module__yprQXG__overlayDark",
  "overlayTip": "feedback-module__yprQXG__overlayTip",
  "pulseDot": "feedback-module__yprQXG__pulseDot",
  "ringLayer": "feedback-module__yprQXG__ringLayer",
  "ringWrap": "feedback-module__yprQXG__ringWrap",
  "scrollTop": "feedback-module__yprQXG__scrollTop",
  "signOut": "feedback-module__yprQXG__signOut",
  "signOutAmbient": "feedback-module__yprQXG__signOutAmbient",
  "signOutBody": "feedback-module__yprQXG__signOutBody",
  "signOutBrand": "feedback-module__yprQXG__signOutBrand",
  "signOutBrandCopy": "feedback-module__yprQXG__signOutBrandCopy",
  "signOutBrandMeta": "feedback-module__yprQXG__signOutBrandMeta",
  "signOutBrandName": "feedback-module__yprQXG__signOutBrandName",
  "signOutContinue": "feedback-module__yprQXG__signOutContinue",
  "signOutDesc": "feedback-module__yprQXG__signOutDesc",
  "signOutFoot": "feedback-module__yprQXG__signOutFoot",
  "signOutMark": "feedback-module__yprQXG__signOutMark",
  "signOutPanel": "feedback-module__yprQXG__signOutPanel",
  "signOutPanelIn": "feedback-module__yprQXG__signOutPanelIn",
  "signOutProgress": "feedback-module__yprQXG__signOutProgress",
  "signOutProgressBar": "feedback-module__yprQXG__signOutProgressBar",
  "signOutSweep": "feedback-module__yprQXG__signOutSweep",
  "signOutTitle": "feedback-module__yprQXG__signOutTitle",
  "spinnerBackdrop": "feedback-module__yprQXG__spinnerBackdrop",
  "spinnerBarScale": "feedback-module__yprQXG__spinnerBarScale",
  "spinnerBox": "feedback-module__yprQXG__spinnerBox",
  "spinnerCircle": "feedback-module__yprQXG__spinnerCircle",
  "spinnerDash": "feedback-module__yprQXG__spinnerDash",
  "spinnerDotBounce": "feedback-module__yprQXG__spinnerDotBounce",
  "spinnerLabel": "feedback-module__yprQXG__spinnerLabel",
  "spinnerLabelLg": "feedback-module__yprQXG__spinnerLabelLg",
  "spinnerOrbitPulse": "feedback-module__yprQXG__spinnerOrbitPulse",
  "spinnerPulse": "feedback-module__yprQXG__spinnerPulse",
  "spinnerRoot": "feedback-module__yprQXG__spinnerRoot",
  "spinnerRootColumn": "feedback-module__yprQXG__spinnerRootColumn",
  "spinnerRootColumnReverse": "feedback-module__yprQXG__spinnerRootColumnReverse",
  "spinnerRootRow": "feedback-module__yprQXG__spinnerRootRow",
  "spinnerRootRowReverse": "feedback-module__yprQXG__spinnerRootRowReverse",
  "spinnerRootWithLabel": "feedback-module__yprQXG__spinnerRootWithLabel",
  "spinnerRotate": "feedback-module__yprQXG__spinnerRotate",
  "spinnerSvg": "feedback-module__yprQXG__spinnerSvg",
  "spinnerWave": "feedback-module__yprQXG__spinnerWave",
  "state": "feedback-module__yprQXG__state",
  "stateAction": "feedback-module__yprQXG__stateAction",
  "stateActionPrimary": "feedback-module__yprQXG__stateActionPrimary",
  "stateActionSecondary": "feedback-module__yprQXG__stateActionSecondary",
  "stateActions": "feedback-module__yprQXG__stateActions",
  "stateCompact": "feedback-module__yprQXG__stateCompact",
  "stateDesc": "feedback-module__yprQXG__stateDesc",
  "stateIcon": "feedback-module__yprQXG__stateIcon",
  "stateIconError": "feedback-module__yprQXG__stateIconError",
  "stateIconMuted": "feedback-module__yprQXG__stateIconMuted",
  "stateTitle": "feedback-module__yprQXG__stateTitle",
  "toast": "feedback-module__yprQXG__toast",
  "toastAction": "feedback-module__yprQXG__toastAction",
  "toastActions": "feedback-module__yprQXG__toastActions",
  "toastBody": "feedback-module__yprQXG__toastBody",
  "toastDismiss": "feedback-module__yprQXG__toastDismiss",
  "toastEnter": "feedback-module__yprQXG__toastEnter",
  "toastError": "feedback-module__yprQXG__toastError",
  "toastInfo": "feedback-module__yprQXG__toastInfo",
  "toastMessage": "feedback-module__yprQXG__toastMessage",
  "toastStack": "feedback-module__yprQXG__toastStack",
  "toastSuccess": "feedback-module__yprQXG__toastSuccess",
  "toastWarning": "feedback-module__yprQXG__toastWarning",
  "waveBar": "feedback-module__yprQXG__waveBar",
  "waveWrap": "feedback-module__yprQXG__waveWrap",
});
